import type { ReactNode } from 'react'
import cx from 'classnames'
import { IconButton } from '@/components/IconButton'
import styles from './FilterCard.module.css'

export interface FilterCardProps {
  children?: ReactNode
  hasError?: boolean
  /**
   * Draws the node that joins the card to a {@link FiltersBuilder}'s rail.
   */
  isOnRail?: boolean
  onRemove?: () => unknown
  isDisabled?: boolean
  /**
   * The remove button gets `${testId}-remove-button`.
   */
  testId?: string
}

/**
 * One filter in a bordered card, with its remove button.
 */
export function FilterCard({
  children,
  hasError,
  isOnRail,
  onRemove,
  isDisabled,
  testId,
}: FilterCardProps) {
  return (
    <div
      className={cx(
        styles.root,
        isOnRail && styles.onRail,
        hasError && styles.invalid,
      )}
      data-test={testId}
    >
      <div className={styles.body}>{children}</div>
      {onRemove && !isDisabled && (
        <div className={styles.actions}>
          <IconButton
            name="close"
            label="Remove filter"
            size={14}
            onPress={onRemove}
            testId={testId && `${testId}-remove-button`}
          />
        </div>
      )}
    </div>
  )
}
